import Card from "../../components/UI/Card";
import {useForm} from "react-hook-form";
import Input from "../../components/UI/form/Input";
import Button from "../../components/UI/Button";
import {useEffect, useState} from "react";
import {useMutation, useQuery} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {setValidationMessage} from "../../util/validationMessage";
import {addBankAccount} from "../../api/setupBank";
import {getProfileInfo} from "../../api/profile";
import {checkPermission} from "../../util/auth";
import {useNavigate} from "react-router-dom";

const SetupBankAccount = () => {
  const [toastId, setToastId] = useState(null);
  const [vendor, setVendor] = useState(null);

  const navigate = useNavigate();
  useEffect(() => {
    if(!checkPermission(['BANK_ACCOUNT_READ'])){
      navigate("/no-access");
    }
  }, [navigate]);

  const {data: vendorInfo} = useQuery({
    queryKey: ['vendor'],
    queryFn: () => getProfileInfo(),
    initialData: () => []
  });

  useEffect(() => {
    if (vendorInfo !== undefined) {
      setVendor(vendorInfo);
    }
  }, [vendorInfo]);

  const {isPending, mutate} = useMutation({
    mutationFn:  (data) => addBankAccount(data),
    onMutate: () => {
      setToastId(toast.loading("Please wait..."))
    },
    onSuccess: (res) => {
      toast.update(toastId, { render: `Bank Account Updated`, type: "success", isLoading: false, autoClose: true });
      // reset();
    },
    onError: (error) => {
      let errorMsg = "Something happened!";
      if (error && error.message && error.message.errors) {
        setValidationMessage(error.message.errors, setError);
        errorMsg = error.message.message;
      }

      toast.update(toastId, { render: errorMsg, type: "error", isLoading: false, autoClose: true });
    }
  });

  const {setError, reset, handleSubmit, setValue, register, formState: { errors }} = useForm();

  useEffect(()=> {
    if (vendor) {
      setValue("account_holder_name", vendor.account_holder_name)
      setValue("account_number", vendor.account_number)
      setValue("routing_number", vendor.routing_number)
    }
  }, [setValue, vendor]);

  const onSubmit = (data) => {
    mutate(data)
  }
  return (
      <div className="">
        <Card title={"Setup Bank Account"}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              <div className="col_12">
                <Input label={'Account Holder Name'}
                       name={'account_holder_name'}
                       errors={errors}
                       type={'text'}
                       validationRules={  {required: true } }
                       register={register}/>
              </div>
              <div className="col_12">
                <Input label={'Account Number'}
                       name={'account_number'}
                       errors={errors}
                       type={'text'}
                       validationRules={  {required: true } }
                       register={register}/>
              </div>
              <div className="col_12">
                <Input label={'Routing Number'}
                       name={'routing_number'}
                       errors={errors}
                       type={'text'}
                       validationRules={  {required: true } }
                       register={register}/>
              </div>
              <div className="col_12">
                <div className="d_flex_end">
                  {checkPermission(['BANK_ACCOUNT_UPDATE']) &&
                      <Button
                          text="update"
                          isPending={isPending}
                          type={"submit"}
                      />
                  }
                </div>
              </div>
            </div>
          </form>
        </Card>
      </div>
  );
}

export default SetupBankAccount